import { Component } from '@angular/core';
@Component({
    selector: 'outside-the-gate',
    styleUrls: ['./outside-the-gate.component.scss'],
    templateUrl: './outside-the-gate.component.html',
})
export class OutsideTheGateLayoutComponent {
}
